import { Injectable, signal } from '@angular/core';

export interface ToastMessage {
  id: number;
  type: 'success' | 'error' | 'warning' | 'info';
  text: string;
}

@Injectable({ providedIn: 'root' })
export class FeedbackService {
  private id = 0;
  private toastsSignal = signal<ToastMessage[]>([]);
  readonly toasts = this.toastsSignal.asReadonly();

  /**
   * Adds a toast message and schedules automatic dismissal.
   * @param type Toast visual severity.
   * @param text Message shown to the user.
   * @returns void.
   */
  show(type: ToastMessage['type'], text: string) {
    const toast = { id: ++this.id, type, text };
    this.toastsSignal.update((items) => [...items, toast]);
    setTimeout(() => this.dismiss(toast.id), 3600);
  }

  /** Shows a success toast. */
  success(text: string) {
    this.show('success', text);
  }

  /** Shows an error toast. */
  error(text: string) {
    this.show('error', text);
  }

  /** Shows a warning toast. */
  warning(text: string) {
    this.show('warning', text);
  }

  /**
   * Removes a toast by id.
   * @param id Toast identifier.
   * @returns void.
   */
  dismiss(id: number) {
    this.toastsSignal.update((items) => items.filter((item) => item.id !== id));
  }
}
